@if (whiteboardService.foreignData | async; as foreignData) {
  <div class="whiteboard-wrapper">
    <div class="active-users">
      <div
        class="toggle-layer"
        *ngIf="userService.ownUser$ | async as user"
        [andorTooltip]="youTooltip">
        <andor-user-avatar [user]="user" [showStatus]="false"></andor-user-avatar>
        <fa-icon [icon]="faEyeSlash" class="toggle visible own"></fa-icon>
      </div>

      @for (layer of foreignData | keyvalue; track layer.key) {
        <div
          class="toggle-layer"
          *ngIf="userStore.get$(layer.key) | async as user"
          (click)="toggleVisibility(layer.key)"
          [andorTooltip]="user.data.name">
          <andor-user-avatar [user]="user" [showStatus]="false"></andor-user-avatar>
          <fa-icon
            [icon]="faEyeSlash"
            class="toggle"
            [ngClass]="{ visible: layer.value.visible }"></fa-icon>
        </div>
      }
    </div>
    <div class="whiteboard">
      <ng-whiteboard
        backgroundColor="transparent"
        strokeColor="{{ color }}"
        fill="transparent"
        (dataChange)="onChange($event)"
        [selectedTool]="tool"
        [enableGrid]="true"></ng-whiteboard>
    </div>
    <div class="whiteboard-controls">
      <div class="tool-category history" tabindex="-1">
        <fa-icon [icon]="faTimeline" class="icon category"></fa-icon>
        <fa-icon
          [icon]="faBackward"
          class="icon tool"
          (mousedown)="whiteboardService.undo()"
          [andorTooltip]="'Undo' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faForward"
          class="icon tool"
          (mousedown)="whiteboardService.redo()"
          [andorTooltip]="'Redo' | translate"
          tabindex="-1"></fa-icon>
      </div>
      <div class="tool-category something" tabindex="-1">
        <fa-icon [icon]="faBroomWide" class="icon category"></fa-icon>
        <fa-icon
          [icon]="faEraser"
          class="icon tool"
          (mousedown)="selectTool(tools.ERASER)"
          [andorTooltip]="'Eraser' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faTrash"
          class="icon tool"
          (mousedown)="whiteboardService.erase()"
          [andorTooltip]="'Clear own Drawings' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faDumpsterFire"
          class="icon tool"
          (mousedown)="clearPage()"
          [andorTooltip]="'Clear all Drawings' | translate"
          tabindex="-1"></fa-icon>
      </div>
      <div class="tool-category shapes" tabindex="-1">
        <fa-icon [icon]="faShapes" class="icon category"></fa-icon>
        <fa-icon
          [icon]="faPenSwirl"
          class="icon tool"
          (mousedown)="selectTool(tools.BRUSH)"
          [andorTooltip]="'Pen Tool' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faDrawSquare"
          class="icon tool"
          (mousedown)="selectTool(tools.RECT)"
          [andorTooltip]="'Rectangle Tool' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faDrawCircle"
          class="icon tool"
          (mousedown)="selectTool(tools.ELLIPSE)"
          [andorTooltip]="'Ellipse Tool' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faRuler"
          class="icon tool"
          (mousedown)="selectTool(tools.LINE)"
          [andorTooltip]="'Line Tool' | translate"
          tabindex="-1"></fa-icon>
      </div>
      <div class="tool-category color" tabindex="-1">
        <fa-icon [icon]="faSwatchbook" class="icon category"></fa-icon>
        @for (color of colors | keyvalue; track $index) {
          <div class="icon tool" (mousedown)="selectColor(color.value)" tabindex="-1">
            <div class="color-preview" [style.backgroundColor]="color.value"></div>
          </div>
        }
      </div>
      <div class="tool-category export" tabindex="-1">
        <fa-icon [icon]="faDownload" class="icon category"></fa-icon>
        <fa-icon
          [icon]="faFileSvg"
          class="icon tool"
          (mousedown)="exportWhiteboard('svg')"
          [andorTooltip]="'Download Whiteboard as SVG' | translate"
          tabindex="-1"></fa-icon>
        <fa-icon
          [icon]="faFilePng"
          class="icon tool"
          (mousedown)="exportWhiteboard('png')"
          [andorTooltip]="'Download Whiteboard as PNG' | translate"
          tabindex="-1"></fa-icon>
      </div>
      <fa-icon [icon]="faWrench" class="icon tools" tabindex="-1"></fa-icon>
    </div>
  </div>

  <!-- Bold-oblique treatment marks the own user's avatar tooltip. -->
  <ng-template #youTooltip>
    <strong>
      <em>{{ 'You' | translate }}</em>
    </strong>
  </ng-template>
}
